/*Generated from the `:::slide{key="7367b55c-4689-45e5-a62a-f444f4324464" slug="multiple"}` (simplified/001/006/二.mdx) directive. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "2",
      children: _jsxs(html.p, {
        children: ["In a mnemonic, the numbers ", _jsx(html.em, {
          children: "two",
          components: html
        }), ", ", _jsx(html.em, {
          children: "three",
          components: html
        }), ", or ", _jsx(html.em, {
          children: "four",
          components: html
        }), " are paired with aliases to describe components that appears multiple times."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "2",
      children: _jsxs(html.p, {
        children: ["e.g. ", _jsx(html.strong, {
          children: "two",
          components: html
        }), " ", _jsx(html.em, {
          children: "lines",
          components: html
        }), " (一)"]
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
